module.exports = __webpack_public_path__ + "img/eye-opened.821d00be.svg";